import type { Tracking } from "@ebay/experience-types-ebay";
import { composeAttrsForClickTracking } from "../../utils/tracking";

const ClusterClickId = "186877";
const ClusterStackedClickId = "186917";

export const trackingDataCluster = (entryPageId?: string): Tracking => composeAttrsForClickTracking(ClusterClickId, "cluster", entryPageId);

export const trackingDataClusterStacked = (entryPageId?: string): Tracking =>
  composeAttrsForClickTracking(ClusterStackedClickId, "cluster_stacked", entryPageId);
